import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CdsLanguageModule } from '@cds/ng-core/lang';
import { CdsPopupModule } from '@cds/ng-web-components/popup';
import { CdsButtonModule } from '@cds/ng-web-components/button';

import { CdWarningPopupComponent } from './cd-warning-popup.component';

@NgModule({
  imports: [CommonModule, CdsPopupModule, CdsLanguageModule, CdsButtonModule, CdWarningPopupComponent],
  exports: [CdWarningPopupComponent],
})
export class CdWarningPopupModule {}
